import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import Header from './templates/Header';
import Footer from './templates/Footer';
import SEO from './templates/SEO';

const Result = () => {
  return <p className="success-message fw-bold text-success">Your Message has been successfully sent. We will contact you soon.</p>;
};

function Contact() {
  const [result, showresult] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    fullname: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const validate = (name, value) => {
    let errors = { ...formErrors };

    switch (name) {
      case 'fullname':
        errors.fullname = !/^[A-Za-z][A-Za-z\s\-]{3,}$/.test(value) ? 'Full Name must be alphabet and at least 3 characters' : '';
        break;
      case 'email':
        errors.email = !/^\S+@\S+\.\S+$/.test(value) ? 'Invalid email address' : '';
        break;
      case 'phone':
        errors.phone = !/^\d{10}$/.test(value) ? 'Phone number must be 10 digits' : '';
        break;
      default:
        break;
    }

    setFormErrors(errors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleKeyUp = (e) => {
    const { name, value } = e.target;
    validate(name, value);
  };

  const isValid = () => {
    return !Object.values(formErrors).some(error => error) &&
           formData.fullname && formData.email && formData.phone;
  };

  const sendEmail = (e) => {
    e.preventDefault();
    if (!isValid()) {
      alert("Please fix the errors before submitting.");
      return;
    }

    emailjs
      .sendForm('service_kx087j8', 'template_rev61j3', e.target, 'EXJNlr7x6Cz38-Sqt')
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });

    e.target.reset();
    showresult(true);
    setTimeout(() => showresult(false), 5000);
    setFormData({ fullname: '', email: '', phone: '', subject: '', message: '' });
    setFormErrors({});
  };

  return (
    <div>
      <SEO title="Contact Page" />
      <Header />

      <div className="best__categories sp_top_70 sp_bottom_80">
        <div className="container">
          <div className="login__heading text-center sp_bottom_20">
            <h2 className="login__title">Contact Trading Whales</h2>
            <p className="login__description">
              Whether you're interested in our courses, mentorship, or just have
              a <br /> quick question — we're here to help.
            </p>

            <a
              href="https://classroom.tradingwhales.in"
              target="_blank"
              rel="noopener noreferrer"
              className="default__button mt-1 d-inline-block"
              style={{ padding: "10px 20px", fontSize: "16px" }}
            >
              Visit Our Classrooms
            </a>
          </div>

          <div className="row">
            <div className="col-xl-4 col-lg-4 col-sm-6">
              <div className="best__categories__item" data-aos="fade-up">
                <a
                  className="best__categories__link"
                  href="https://maps.app.goo.gl/QPCTw1yT6u3aj1Tb7"
                >
                  <div className="best__categories__info">
                    <h3 className="best__categories__name">Address</h3>
                    <span className="best__categories__more sp_top_10">
                      Road No. 36, Jawahar Colony, <br /> Jubilee Hills,
                      Hyderabad, Telangana 500033
                    </span>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-sm-6">
              <div className="best__categories__item" data-aos="fade-up">
                <a
                  className="best__categories__link"
                  href="mailto:info@tradingwhales.in"
                >
                  <div className="best__categories__info">
                    <h3 className="best__categories__name">Email</h3>
                    <span className="best__categories__more">
                      info@tradingwhales.in
                    </span>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-sm-6">
              <div className="best__categories__item" data-aos="fade-up">
                <a className="best__categories__link" href="tel:+91 9491065567">
                  <div className="best__categories__info">
                    <h3 className="best__categories__name">Contact Number</h3>
                    <span className="best__categories__more">
                      +91 94910 65567
                    </span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="loginarea sp_bottom_100">
        <div className="container">
          <div className="row align-items-start">
            <div className="col-xl-6 col-lg-6 col-md-12">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.4604295775025!2d78.4003311!3d17.437663200000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91463b7ebb4b%3A0x16a4ba4ed2262687!2sRoad%20No.%2036%2C%20Hyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1744955950490!5m2!1sen!2sin"
                width="100%"
                height="600"
                style={{ border: "0" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <div className="col-xl-6 col-lg-6 col-md-6">
              <div className="loginarea__wraper">
                <div className="login__heading">
                  <h5 className="login__title">Get in Touch</h5>
                </div>

                <form onSubmit={sendEmail}>
                  <div className="login__form">
                    <input
                      className="common__login__input"
                      type="text"
                      placeholder="Enter your Full Name"
                      name="fullname"
                      onKeyUp={handleKeyUp}
                      onChange={handleChange}
                    />
                    {formErrors.fullname && (
                      <small style={{ color: "red" }}>
                        {formErrors.fullname}
                      </small>
                    )}
                  </div>
                  <div className="login__form">
                    <input
                      className="common__login__input"
                      type="text"
                      placeholder="Enter your email address"
                      name="email"
                      onKeyUp={handleKeyUp}
                      onChange={handleChange}
                      required
                    />
                    {formErrors.email && (
                      <small style={{ color: "red" }}>{formErrors.email}</small>
                    )}
                  </div>
                  <div className="login__form">
                    <input
                      className="common__login__input"
                      type="text"
                      placeholder="Enter your phone number"
                      name="phone"
                      onKeyUp={handleKeyUp}
                      onChange={handleChange}
                      required
                    />
                    {formErrors.phone && (
                      <small style={{ color: "red" }}>{formErrors.phone}</small>
                    )}
                  </div>
                  <div className="login__form">
                    <input
                      className="common__login__input"
                      type="text"
                      placeholder="Subject of your message"
                      name="subject"
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="login__form">
                    <textarea
                      name="message"
                      className="create__course__textarea"
                      rows="5"
                      placeholder="Type your message here"
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                  <div className="login__button">
                    <input
                      type="submit"
                      className="default__button"
                      value="Send Message"
                    />
                  </div>
                </form>

                <div className="form-group">{result ? <Result /> : null}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Contact;
